// Memoria de filtros por usuario y dispositivo (localStorage). Se borra al cerrar sesión.
export const FILTERS_PREFIX = "bf:";

export function clearPersistedFilters() {
    try {
        Object.keys(localStorage).filter((k) => k.startsWith(FILTERS_PREFIX)).forEach((k) => localStorage.removeItem(k));
    } catch { /* navegador sin almacenamiento */ }
}
